import $ from 'jquery';
import { aspectRatioClassPattern, dataLayerEventExist } from './helpers';

document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];
  const filterButtons = document.querySelectorAll('.filter-button');
  const masonryGrid = document.querySelector('.masonry-grid');
  const slider = $('[data-carousel="multiple"]');
  let activeCategory = null;
  let activeCategories = []; // for our work page

  if (filterButtons.length > 0) {
    const firstButton = filterButtons[0];
    const category = firstButton.getAttribute('data-category');
    activeCategory = category;
    if (!masonryGrid) {
      firstButton.classList.add('active');
    }
  }

  function recalculateGridLayout(masonryItems) {
    // Sort DOM elements based on visibility
    const sortedItems = Array.from(masonryItems).sort((a, b) => {
      const aDisplay = a.style.display === 'none' ? 1 : 0;
      const bDisplay = b.style.display === 'none' ? 1 : 0;
      return aDisplay - bDisplay;
    });

    // remove and reattach the grid items
    masonryGrid.innerHTML = '';
    sortedItems.forEach((item) => masonryGrid.appendChild(item));

    // keeping this in here for now for future troubleshooting... shouldn't be needed ultimately though
    // Reapply grid positioning for visible items
    // let counter = 0;
    // sortedItems.forEach((item) => {
    //   if (item.style.display === 'flex') {
    //     const nthChildIndex = (counter % 8) + 1; // Calculate the nth-child position (1 to 8)
    //     let rowSpan;

    //     // Determine row span based on the nth-child logic in CSS
    //     switch (nthChildIndex) {
    //       case 1: // 8n-7
    //         rowSpan = 2;
    //         break;
    //       case 2: // 8n-6
    //         rowSpan = 3;
    //         break;
    //       case 3: // 8n-5
    //         rowSpan = 3;
    //         break;
    //       case 4: // 8n-4
    //         rowSpan = 2;
    //         break;
    //       case 5: // 8n-3
    //         rowSpan = 2;
    //         break;
    //       // case 6: // 8n-2
    //       //   rowSpan = 3;
    //       //   break;
    //       // case 7: // 8n-1
    //       //   rowSpan = 3;
    //       //   break;
    //       case 8: // 8n
    //         rowSpan = 2;
    //         break;
    //       default:
    //         rowSpan = 2;
    //     }

    //     // Alternate columns: 1, 2, 1, 2...
    //     // const column = counter % 2 === 0 ? 1 : 2;

    //     // item.style.gridColumn = column;
    //     item.style.gridRow = `span ${rowSpan}`;

    //     counter++;
    //   }
    // }
    // );
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      const category = this.getAttribute('data-category');
      const filter = this.getAttribute('data-filter');
      const isActive = activeCategories.includes(category);
      const masonryItems = document.querySelectorAll('.masonry-item');

      const categoryClickEvent = new CustomEvent('categoryClick', {
        detail: { category, originalEvent: event }
      });

      document.dispatchEvent(categoryClickEvent);

      if (isActive) {
        activeCategories = activeCategories.filter((c) => c !== category);
      } else {
        activeCategories.push(category);

        const gtmEvent = 'categoryClick';

        if (!dataLayerEventExist(gtmEvent, category)) {
          window.dataLayer.push({
            event: gtmEvent,
            eventLabel: category,
          });
        }
      }

      const itemPositions = Array.from(masonryItems).reduce((acc, item) => {
        if (item.style.display !== 'none') {
          acc.push({ item, rect: item.getBoundingClientRect() });
        }
        return acc;
      }, []);

      // our work page
      if (masonryGrid) {
        masonryItems.forEach((item) => {
          const itemCategories = item.getAttribute('data-category').split(' ');
          const shouldShow =
            activeCategories.length === 0 ||
            activeCategories.some((cat) => itemCategories.includes(cat));

          item.style.display = shouldShow ? 'flex' : 'none';

          if (shouldShow) {
            item.classList.add('visible');
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
            item.classList.remove('visible');
          }
        });

        masonryGrid.offsetHeight; // force reflow for animation purposes

        const aspectRatioClasses = aspectRatioClassPattern();
        let counter = 0;

        masonryItems.forEach((item) => {
          if (item.style.display === 'flex') {
            item.classList.remove('landscape', 'portrait', 'square');

            const aspectRatioClass =
              aspectRatioClasses[counter % aspectRatioClasses.length];
            item.classList.add(aspectRatioClass);

            counter++;
          }
        });

        recalculateGridLayout(masonryItems);

        itemPositions.forEach(({ item, rect: oldRect }) => {
          if (item.style.display === 'flex') {
            const newRect = item.getBoundingClientRect();
            const dx = oldRect.left - newRect.left;
            const dy = oldRect.top - newRect.top;

            item.style.transform = `translate(${dx}px, ${dy}px)`;
            item.style.transition = 'none';
            requestAnimationFrame(() => {
              item.style.transform = '';
              item.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
            });
          }
        });

        filterButtons.forEach((button) => {
          const buttonCategory = button.getAttribute('data-category');
          if (activeCategories.includes(buttonCategory)) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      }

      // front page
      function resetAndFilterSlider(slider, category) {
        if (slider.length) {
          slider.find('.slick-track').stop(true, true).fadeTo(200, 0, function () {
            // Remove any existing filters
            slider.slick('slickUnfilter');
      
            // Apply new filter if category is specified
            if (category && category !== 'all') {
              slider.slick('slickFilter', function () {
                const card = $(this).find('.our-work-card');
                const categories = card.data('category');
                return categories && categories.split(' ').includes(category);
              });
            }
      
            // Ensure visibility and reinitialize slick slider state
            slider.slick('setPosition'); // Ensures Slick recalculates its layout
            slider.find('.slick-track').fadeTo(200, 1);
          });
        }
      }

      
      
      if (slider.length) {
        if (activeCategory === category) {
          activeCategory = null;
          resetAndFilterSlider(slider, 'all');
          $(this).removeClass('active');
        } else {
          activeCategory = category;
          resetAndFilterSlider(slider, category);
          $('.filter-button').removeClass('active');
          $(this).addClass('active');
        }

        
      }
      
    });
  });
  
  // fix for bug in slick slider - responsive settings in global.js causes
  // issue where filtered out slides do not return after unfiltering.
  // known issue - https://github.com/kenwheeler/slick/issues/2434 
  function updateCarouselSettings() {
    const windowWidth = window.innerWidth;
  
    if (windowWidth > 991) {
      // For desktop
      $('[data-carousel="multiple"]').slick('slickSetOption', {
        slidesToShow: 2,
        slidesToScroll: 1,
      }, true);
    } else {
      // For mobile
      $('[data-carousel="multiple"]').slick('slickSetOption', {
        slidesToShow: 1,
        slidesToScroll: 1,
      }, true);
    }
  }
  
  if (slider.length) {
    updateCarouselSettings();
  
    $(window).on('resize', updateCarouselSettings);
  }
          
});
